export const AVATAR_SIZE = {
  xsmall: '32px',
  small: '48px',
  medium: '60px'
} as const;
